import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  return <section className="py-20 px-4 bg-sage-light/30 relative overflow-hidden" data-id="element-55">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        <div className="text-center mb-12" data-id="element-57">
          <div className="inline-flex items-center gap-2 bg-urgency text-white text-sm font-bold px-4 py-2 rounded-full uppercase tracking-wider mb-6 animate-pulse" data-id="element-58">
            <span data-id="element-59">⚡</span> DISPONIBLE SOLO HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-60">
          {[{
          title: 'Plan Anti-Crisis',
          desc: 'Protocolo de emergencia para los momentos de alta activación. 5 técnicas de regulación inmediata que puedes usar en cualquier lugar.',
          value: 37,
          img: 'https://cdn.magicpatterns.com/uploads/agUU7oKuJRRb6TFS7VDekQ/Gemini_Generated_Image_ws4013ws4013ws40.png'
        }, {
          title: 'Rutina Nocturna Restauradora',
          desc: 'Secuencia de 15 minutos antes de dormir que activa el sistema nervioso parasimpático. Diseñada para mujeres con mente que no para.',
          value: 27,
          img: 'https://cdn.magicpatterns.com/uploads/n3P4faehiyf3ASdffhyQcq/Gemini_Generated_Image_w9efwiw9efwiw9ef.png'
        }].map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-5 sm:p-6 md:p-8 border-2 border-gold/30 shadow-lg relative flex flex-col md:flex-row gap-5 md:gap-6 items-center" data-id="element-61">
              <div className="absolute -top-3 right-4 md:-top-3 md:-right-3 bg-gold text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-md z-10" data-id="element-62">
                BONO EXCLUSIVO
              </div>

              {bono.img && <img src={bono.img} alt={bono.title} className="w-28 sm:w-32 md:w-40 shrink-0 rounded-xl" data-id="element-63" />}

              <div className="flex-1 text-center md:text-left" data-id="element-64">
                <h3 className="font-heading font-bold text-xl sm:text-2xl text-teal mb-3 break-words" data-id="element-65">
                  {bono.title}
                </h3>
                <p className="text-neutral-gray font-sans leading-relaxed mb-4" data-id="element-66">
                  {bono.desc}
                </p>
                <p className="font-bold text-relief" data-id="element-67">
                  GRATIS{' '}
                  <span className="text-neutral-gray/50 font-normal text-sm ml-2" data-id="element-68">
                    <PriceDisplay amountUSD={bono.value} className="line-through" data-id="element-69" />
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-70">
          <p className="text-urgency font-bold text-sm md:text-base bg-urgency/10 inline-block px-6 py-3 rounded-xl border border-urgency/20" data-id="element-71">
            ⚠️ Esta combinación de bonos solo está disponible mientras dure esta
            página
          </p>
        </div>
      </div>
    </section>;
}